import { AlertComponent } from '@app/notifications/shared/alert.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NotificationsComponent } from '@app/notifications/shared/notifications.component';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  declarations: [AlertComponent, NotificationsComponent],
  exports: [AlertComponent, NotificationsComponent],
  imports: [CommonModule, SharedModule],
  providers: []
})
export class NotificationsModule {}
